module.exports = __webpack_public_path__ + "static/media/sun_blue.7f6e456e.svg";